import { useNavigate } from 'react-router-dom';
import { CHECKLIST_ITEMS } from '../../utils/onboarding';
import styles from './Onboarding.module.css';

// Shared by the final sign-up step and the Dashboard card: `items` come from GET /api/onboarding/checklist.
export default function GetStartedChecklist({ items, onDismiss }) {
  const navigate = useNavigate();
  const status = Object.fromEntries(items.map((i) => [i.key, i]));
  const remaining = items.filter((i) => !i.done).length;

  return (
    <div>
      <div className={styles.sectionLabel}>
        Get started <span className={styles.badge}>{remaining}</span>
        {onDismiss && (
          <button type="button" className={styles.link} style={{ marginLeft: 'auto', textTransform: 'none', fontWeight: 400 }} onClick={onDismiss}>
            Dismiss
          </button>
        )}
      </div>
      <ul className={styles.checklist}>
        {CHECKLIST_ITEMS.map((item) => {
          const s = status[item.key] || {};
          const subtitle = item.key === 'invites' ? `${item.subtitle} · ${s.pending || 0} pending` : item.subtitle;
          return (
            <li key={item.key}>
              <button type="button" className={styles.checklistItem} onClick={() => navigate(item.path)}>
                <span className={`${styles.checkCircle} ${s.done ? styles.checkCircleDone : ''}`} aria-hidden="true">{s.done ? '✓' : ''}</span>
                <span className={styles.checklistText}>
                  <strong>{item.title}</strong>
                  <small>{subtitle}</small>
                </span>
                <span aria-hidden="true" className={styles.chevron}>›</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
